import httpClient from '@/http-client'
import config from '../config'

export const get = (options = {}) => {
  return httpClient
    .get(`${config.apiPrefix}/products`, options)
    .then(response => response.data)
    .catch(error => Promise.reject(error.response ? error.response.data : error))
}

export const getSaleCodes = (productId, options = {}) => {
  return httpClient
    .get(`${config.apiPrefix}/products/${productId}/sale-codes`, options)
    .then(response => response.data)
    .catch(error => Promise.reject(error.response ? error.response.data : error))
}

export const getByBarcode = (barcode, scale = false) => {
  return httpClient
    .get(`${config.apiPrefix}/products/by-barcode/${encodeURIComponent(barcode)}`, { params: { scale: scale ? 1 : 0 } })
    .then(response => response.data)
    .catch(error => Promise.reject(error.response
      ? { ...error.response.data, status: error.response.status }
      : error))
}

export default { get, getSaleCodes, getByBarcode }
